import { render, staticRenderFns } from "./ValidarBase.vue?vue&type=template&id=3df85168"
import script from "./ValidarBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidarBase.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports